function replaceTokens(text, params) {
  const tokens = text.match(/{\w+}/g) || [];
  let finalText = text;

  tokens.forEach((token) => {
    const paramKey = token.slice(1, -1);
    const paramValue = params[paramKey] || '';

    finalText = finalText.replace(token, paramValue);
  });

  return finalText;
}

module.exports = replaceTokens;
